<div class="user-bar" (click)="toggleMenu()">
  <div class="user-name">
    {{ profile?.first_name | slice: 0:1 | uppercase
    }}{{ profile?.last_name | slice: 0:1 | uppercase }}
  </div>
  <div class="arrow" inlineSVG="/assets/svg/arrow-down.svg"></div>
</div>
<div
  class="s-user_menu-body"
  aria-labelledby="dropdownMenuButton"
  [@flyInOutState]="showMenu ? 'shown' : 'hidden'"
>
  <div class="mobile-header">
    <a class="logo" routerLink="/"><img src="/assets/img/logo.png" alt="" /></a>
    <a
      class="icon-close close"
      (click)="onClick()"
      [inlineSVG]="'/assets/svg/close.svg'"
    ></a>
  </div>
  <div class="mobile-links">
    <div class="s-user_menu-body-links">
      <ot-search></ot-search>
      <a href="" routerLink="/deal" (click)="onClick()">Deals</a>
      <!--      <a href="" routerLink="/contacts" (click)="onClick()">Contacts</a>-->
      <a href="" routerLink="/reports" (click)="onClick()">Reports</a>
    </div>
  </div>
  <div class="s-user_menu-body-links">
    <!-- <a class="bottom-border w-100" [href]="fultongraceUrl + '/account/contacts/'" (click)="onClick()">{{
      profile?.types?.includes('agent') ? 'My Contacts' : 'Contacts'
    }}</a> -->
    <a
      class="link"
      [href]="fultongraceUrl + '/account/my-profile/'"
      (click)="onClick()"
    >
      <div [inlineSVG]="'/assets/icon/user-icon.svg'" class="user-icon"></div>
      My Profile
    </a>
    <!-- <a [href]="fultongraceUrl + '/account/dashboard/'" (click)="onClick()"
      >Hub</a
    > -->
    <a class="link" [href]="fultongraceUrl" (click)="onClick()">
      <div [inlineSVG]="'/assets/icon/icon-logo.svg'" class="icon-logo"></div>
      FultonGrace.com
    </a>
    <div class="separator"></div>
    <a class="link log-out" href="" (click)="logout($event)">
      <div>
        <img src="/assets/icon/Log-Out.svg" height="24" width="24" />
        <span>Log Out</span>
      </div>
    </a>
  </div>
</div>
